import React from "react";
import { storyblokEditable } from "@storyblok/react";
import { useNavigate } from "react-router-dom";
import { NotificationStripModel } from "../Models/NotificationStripModel";

import "./NotificationStrip.css";

const NotificationStrip: React.FC<{ blok: NotificationStripModel }> = ({
  blok,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (blok.url?.cached_url) {
      if (blok.url?.linktype === "story") {
        navigate(`/${blok.url.cached_url}`);
      } else {
        const url = new URL(blok.url.cached_url, window.location.origin);
        window.location.href = url.href;
      }
    }
  };

  if (!blok.active) return null;

  return (
    <div
      onClick={handleClick}
      {...storyblokEditable(blok)}
      className="notification-strip"
      style={{ backgroundColor: blok.stripColor }}
    >
      <div className="Text">
        <span style={{ color: blok.textColor }}>{blok.text}</span>
      </div>
    </div>
  );
};

export default NotificationStrip;
